module.exports = __webpack_public_path__ + "img/icon-budget.90dfcc7a.svg";